import { useAppSelector } from '../../hooks';
import ShortAddress from '../ShortAddress';
import classes from './NavBar.module.css';
import logo from '../../assets/Pegapal.png';
import { useState } from 'react';
import { useEtherBalance, useEthers } from '@usedapp/core';
import WalletConnectModal from '../WalletConnectModal';
// import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { Nav, Navbar, Container } from 'react-bootstrap';
import testnetNoun from '../../assets/transparent_pega.png';
import clsx from 'clsx';
import config, { CHAIN_ID } from '../../config';
import { buildEtherscanAddressLink } from '../../utils/etherscan';
import { ExternalURL, externalURL } from '../../utils/externalURL';

const NavBar = () => {
  const activeAccount = useAppSelector(state => state.account.activeAccount);
  const { deactivate } = useEthers();

  // const history = useHistory();
  const treasuryBalance = useEtherBalance(config.addresses.pegasusTreasury);
  const daoEtherscanLink = buildEtherscanAddressLink(config.addresses.pegasusTreasury);

  const [showConnectModal, setShowConnectModal] = useState(false);

  const showModalHandler = () => {
    setShowConnectModal(true);
  };
  const hideModalHandler = () => {
    setShowConnectModal(false);
  };

  const connectedContent = (
    <>
      <Nav.Item>
        <Nav.Link className={clsx(classes.nounsNavLink, classes.addressNavLink)} disabled>
          <span className={classes.greenStatusCircle} />
          <span>{activeAccount && <ShortAddress address={activeAccount} avatar={true} />}</span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          className={clsx(classes.nounsNavLink, classes.disconnectBtn)}
          onClick={() => {
            setShowConnectModal(false);
            deactivate();
            setShowConnectModal(false);
          }}
        >
          DISCONNECT
        </Nav.Link>
      </Nav.Item>
    </>
  );

  const disconnectedContent = (
    <>
      <Nav.Link
        className={clsx(classes.nounsNavLink, classes.connectBtn)}
        onClick={showModalHandler}
      >
        CONNECT WALLET
      </Nav.Link>
    </>
  );

  // const useStateBg =
  //   history.location.pathname === '/' ||
  //   history.location.pathname.includes('/pegasus') ||
  //   history.location.pathname.includes('/auction');

  return (
    <>
      {showConnectModal && activeAccount === undefined && (
        <WalletConnectModal onDismiss={hideModalHandler} />
      )}
      <Navbar expand="lg" className={classes.navContainer}>
        <Container>
          <Navbar.Brand as={Link} to="/" className={classes.navBarBrand}>
            <img
              src={logo}
              width="85"
              height="85"
              className="d-inline-block align-middle"
              alt="Pegasus DAO logo"
            />
          </Navbar.Brand>
          {Number(CHAIN_ID) !== 10 && (
            <Nav.Item>
              <img className={classes.testnetImg} src={testnetNoun} alt="testnet pegasus" />
              TESTNET
            </Nav.Item>
          )}
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse className="justify-content-end">
            <Nav.Link
              href={externalURL(ExternalURL.dashboard)}
              className={classes.nounsNavLink}
              rel="noreferrer"
            >
              Dashboard
            </Nav.Link>
            <Nav.Link
              href={externalURL(ExternalURL.staking)}
              className={classes.nounsNavLink}
              rel="noreferrer"
            >
              STAKE
            </Nav.Link>
            <Nav.Item>
              {treasuryBalance && (
                <Nav.Link href={daoEtherscanLink} className={classes.nounsNavLink} rel="noreferrer">
                  TREASURY
                </Nav.Link>
              )}
            </Nav.Item>
            <Nav.Link
              href={externalURL(ExternalURL.notion)}
              className={classes.nounsNavLink}
              rel="noreferrer"
            >
              MEDIUM
            </Nav.Link>

            {activeAccount ? connectedContent : disconnectedContent}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default NavBar;
